module.exports = __webpack_public_path__ + "img/share-banner.40922dcc.png";